import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar_poc'
import ShapeTwo from '../components/shape-two'
import TeamOne from '../components/team-one'
import Shape from '../components/shape'
import Footer from '../components/footer'
import SEO from '../components/seo'
// import bg1 from '../assets/images/bg.jpg'
import bg1 from '../assets/images/bg-profile.jpg'
import { services_india_growth } from '../data'
import aboutImg2 from '../assets/images/education/indiagrowthimage.png'

export default function PageIndiaGrowth() {
  return (
    <>
     <Navbar/> 
     <SEO
  title="Optimize Your India Operations – Growth, Culture, and Leadership"
  description="Already in India? We help you scale wisely with leadership alignment, cultural integration, and AI-driven operational improvements."
  url="https://www.pioneeroneglobal.com/india-optimization"
  image="https://www.pioneeroneglobal.com/images/og-optimization.jpg"
/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">India - Growth</h4>
                          <p className="text-muted mb-0">Already in India but Facing Challenges? Let’s Fix What’s Not Working — and Set You Up to Scale.</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                 <li className="list-inline-item"><Link to="/page-services" className="text-uppercase fw-bold text-dark">Services</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">Services - India Growth</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">India - Growth Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Already operational? Let’s level up. Our India Optimization services enhance compliance, improve financial visibility, reduce risk, and deepen cultural alignment — helping you grow with clarity, confidence, and a long-term mindset.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {services_india_growth.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <Icon className="h2 text-primary"/>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.shortDescription}</p>
                            <Link to={`/page-service-single/${item.id}`}  className="text-dark">Read More <i className="mdi mdi-chevron-right align-middle"></i></Link>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
      <div className="container mt-100 mt-60">
          <div className="row align-items-center">
              <div className="col-md-5 order-1 order-md-2 text-end">
                  <img src={aboutImg2} className="img-fluid shadow-lg rounded-top-pill rounded-bottom-5" alt=""/>
              </div>

              <div className="col-md-7 order-2 order-md-1 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="section-title">
                  <h4 className="title mb-4">More Than a Fix</h4>
                            <p className="text-muted mx-auto">If your India operations aren’t working, the solution isn’t always just structural.</p>
                            
                            <p className="text-muted">Sometimes the real shift comes from re-centering around values: transparency, accountability, collaboration, and clarity of purpose.</p>
                      <p className="text-muted">At Pioneer One Global, we go beyond quick fixes — helping you realign your teams, partners, and workflows around a model that’s not only compliant but deeply coherent.</p>
                      <p className="text-muted">We draw from India’s timeless principles — from dharma to discipline — to help you lead with clarity and rebuild with strength.</p>
                      <p className="text-muted"><b>When you realign with the right roots, growth follows naturally.</b></p>

                  </div>
              </div>
          </div>
      </div>
      <div className="container mt-100 mt-60">
          <div className="bg-white rounded p-md-5 p-4 p-sm-0 shadow">
              <div className="row align-items-center">
                  <div className="col-sm-7">
                      <div className="text-sm-start">
                          <h4>Ready to grow with India?</h4>
                       </div>
                  </div>

                  <div className="col-sm-5 mt-4 mt-sm-0">
                      <div className="text-sm-end">
                          <Link to="/contact" className="btn btn-outline-primary"><i className="mdi mdi-phone-outline"></i> Let's talk!</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
